import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { Spin } from 'antd';
import WrapComps from '@/components/wrapComps';

import routers from './routes/index';
// 路由处理方式

const changeRouter = (r) => r.map((item) => {
  const route = item;
  if (route.children) {
    route.children = changeRouter(item.children);
  }
  route.element = (
    <Suspense fallback={(
      <div style={{ textAlign: 'center', paddingTop: 50 }}>
        <Spin />
      </div>
    )}
    >

      {route.class ? <WrapComps el={item.component} /> : <item.component />}
    </Suspense>
  );
  return route;
});
const App = () => (
  useRoutes(changeRouter(routers))
);

export default App;
